//[mh] INC1465998: the contract between a failed sign-in callback (AuthService) and the notice on the home page.
// The callback leaves for /?signin=failed&ref=<reference>[&reason=clock]; the per-tab values below survive the
// STS round trip in sessionStorage.

export const SIGN_IN_IDP = 'mcb.signInIdp'
export const SIGN_IN_FAILURES = 'mcb.signInFailures'

// no 0/O, 1/I, 2/Z, 5/S or 8/B, so the reference survives being read out over the phone
const REFERENCE_CHARACTERS = 'ACDEFGHJKMNPQRTUVWXY34679'
const REFERENCE = /^[A-Z0-9]{6}$/

const readSession = key => {
    try {
        return sessionStorage.getItem(key)
    } catch (e) {
        return null
    }
}

export const newSignInReference = () =>
    Array.from({length: 6}, () =>
        REFERENCE_CHARACTERS.charAt(Math.floor(Math.random() * REFERENCE_CHARACTERS.length))
    ).join('')

export const signInFailurePath = (reference, clock) =>
    `/?signin=failed&ref=${reference}${clock ? '&reason=clock' : ''}`

export const rememberedIdp = () => readSession(SIGN_IN_IDP) || undefined

export const readSignInFailure = (search = window.location.search) => {
    const params = new URLSearchParams(search)
    if (params.get('signin') !== 'failed') return null
    const reference = params.get('ref')
    return {
        reference: REFERENCE.test(reference) ? reference : null,
        clock: params.get('reason') === 'clock',
        repeated: Number(readSession(SIGN_IN_FAILURES)) > 1,
        salesforce: Boolean(rememberedIdp())
    }
}
